import { INVESTMENT_EXPERIENCE_VALUES } from "@tastyworks/tastyworks-api"
import { boolean, object, string } from "yup"
import { INVESTMENT_EXPERIENCES } from "@tastyworks/shared-utils/misc/constants"

export const futuresTradingAddAccountSchema = object({
  addFuturesAccount: boolean().required(),
})

export const futuresTradingExperienceSchema = object({
  futuresTradingExperience: string<INVESTMENT_EXPERIENCES>()
    .oneOf(INVESTMENT_EXPERIENCE_VALUES)
    .required(),
})

export const futuresTradingSchema = object({
  futuresTradingAddAccount: futuresTradingAddAccountSchema,
  futuresTradingExperience: futuresTradingExperienceSchema,
})
